import React from 'react';
import { Radio, Header, Checkbox } from 'semantic-ui-react'

const AdminRolesFormsInputsRadioGroup = ({field, form: {touched, errors}, ...props}) => {
    const hasError = (errors[field.name] && [field.name]) ? true : false;
    console.log('', props)
    console.log(field)
    return (
        <div className="field">
            <Checkbox 
                name={field.name}
                id={field.name} 
                checked={field.value}
                label={props.label} 
                onChange={field.onChange} 
                onBlur={field.onBlur}
                style={{display: 'block', padding: 5}}
                disabled={props.disabled}
            />
            {hasError && <div>{errors[field.label]}</div>}
        </div>
    );
}

export default AdminRolesFormsInputsRadioGroup;